module.exports = {
  email: 'reevlama@reevtech.in',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/reev-create',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/reevanthlofficial',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/reevanth.lama.9',
    },
    {
      name: 'Spotify',
      url: 'https://open.spotify.com/artist/5P48QEM30a2tYeYBXhXLY9',
    },
    {
      name: 'Youtube',
      url: 'https://www.youtube.com/channel/UCM98ZSegyj1kFrRdwb2ivlw',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/ReevanthLama',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/reevanth-lama-129ab1159',
    },
    
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    // {
    //   name: 'Work',
    //   url: '/#projects',
    // },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
